'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('alertsService', function($q, userStore, dispatcher, apiEndpointFactory, userService) {

  return {
    alertsPreload: function(data = undefined) {
      if(data && data.account){
        if (!userStore.getIrn()) {
          userService.setCurrentUserAccount({
            irn: data.account,
            accountHash: data.accountHash
          });
        }
      }
      let irn = userStore.getIrn();

      var endpoint = apiEndpointFactory.new({
        endpointUrl: '/' + irn + '/alerts',
        authRequired: true,
        allowedMethods: ['get']
      });

      if (irn !== undefined) {
        return endpoint.get().then(function(response) {
          dispatcher.dispatch('psob:alertLoaded', response.data);
          return response.data;
        }, function(response) {
          return $q.reject(response.status);
        });
      }
    }
  };
});
